import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProdOrdersUnInvoiced, getProdOrdersInvoiced } from '../modules/orderdata';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import TabPanel from '../common/tabpanel';
import ProductionOrderListView from './productionorderlistview';
import { useTranslation } from 'react-i18next';

export default function ProductionContainer(props) {
    const invoicedOrders = useSelector((state) => state.orderdata.invoicedOrders);
    const unInvoicedOrders = useSelector((state) => state.orderdata.unInvoicedOrders);
    const parameters = useSelector((state) => state.parameterdata.parameters);
    const fetchingUnInvoiced = useSelector((state) => state.orderdata.isFetchingProdOrdersUnInvoiced);
    const fetchingInvoiced = useSelector((state) => state.orderdata.isFetchingProdOrdersInvoiced);

    const userProfile = useSelector((state) => state.authentication.userProfile);
    const dispatch = useDispatch();
    const [tab, setTab] = useState(0);
    const { t } = useTranslation();

    useEffect(() => {
        if (!unInvoicedOrders && !fetchingUnInvoiced) {
            dispatch(getProdOrdersUnInvoiced());
        }
        if (!invoicedOrders && !fetchingInvoiced && tab === 1) {
            dispatch(getProdOrdersInvoiced());
        }
        if (tab === 2) {
            if (!unInvoicedOrders && !fetchingUnInvoiced) {
                dispatch(getProdOrdersUnInvoiced());
            }
            if (!invoicedOrders && !fetchingInvoiced) {
                dispatch(getProdOrdersInvoiced());
            }
        }
    }, [tab, unInvoicedOrders, invoicedOrders, dispatch, fetchingUnInvoiced, fetchingInvoiced]);

    const handleTabChange = (event, value) => {
        setTab(value);
    };

    return (
        <div>
            <Grid container>
                <Grid item xs={12}>
                    <AppBar position="static" color="default">
                        <Box display="flex" justifyContent="center" width="100%">
                            <Tabs
                                value={tab}
                                onChange={handleTabChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="scrollable"
                                scrollButtons="auto">
                                <Tab
                                    value={0}
                                    label={
                                        t('production.unInvoiced') +
                                        ' (' +
                                        (unInvoicedOrders ? unInvoicedOrders.length : '-') +
                                        ')'
                                    }
                                />
                                <Tab
                                    value={1}
                                    label={
                                        t('invoice.invoiced') +
                                        ' (' +
                                        (invoicedOrders ? invoicedOrders.length : '-') +
                                        ')'
                                    }
                                />
                            </Tabs>
                        </Box>
                    </AppBar>
                    <TabPanel value={tab} index={0}>
                        <ProductionOrderListView
                            productionOrders={unInvoicedOrders}
                            userProfile={userProfile}
                            history={props.history}
                            parameters={parameters}
                        />
                    </TabPanel>
                    <TabPanel value={tab} index={1}>
                        <ProductionOrderListView
                            productionOrders={invoicedOrders}
                            userProfile={userProfile}
                            history={props.history}
                            parameters={parameters}
                        />
                    </TabPanel>
                </Grid>
            </Grid>
        </div>
    );
}
